import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, createVNode as _createVNode, withCtx as _withCtx, isRef as _isRef, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, createSlots as _createSlots, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-85c529f4"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "phone-show"
}
const _hoisted_2 = { style: {"height":"100%","align-items":"center","display":"flex","float":"right","margin-right":"10px"} }

import { onBeforeMount, h, ref, watch, computed } from 'vue'
import {
	NEmpty, NIcon, NMenu, NGrid, NGi, NAvatar, NDropdown, NButton, NModal,
	NPopover, NSpace, NButtonGroup, NBadge, NDrawer, NDrawerContent
} from 'naive-ui'
import type { MenuOption } from 'naive-ui'
import {
	BookOutline as BookIcon,
	PersonOutline as PersonIcon,
	WineOutline as WineIcon
} from '@vicons/ionicons5'
import { Book, Video, Music, Gamepad } from '@vicons/fa'
import { LanguageOutlined as LangIcon } from '@vicons/material'
import { Bell as BellIcon } from '@vicons/tabler'
import { Menu as MenuIcon } from '@vicons/ionicons5'
import getBase from '@/utils/base';
import $msg from '@/utils/message';
import { useI18n } from 'vue-i18n';
import UserInfoModal from '@/components/system/UserInfoModal.vue';
import EditPasswordModal from '@/components/system/EditPasswordModal.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'HeaderComp',
  setup(__props) {

const { $api, $store, $router, t, reInitAuth } = getBase();
const user = computed(() => $store.state.auth.user);
const logoSrc = computed(() => {
	return require(`@/assets/img/logo-${$store.state.project}.png`);
});

const { locale } = useI18n();

let activeKey = ref(null);
let lang = locale;
let drawerShow = ref(false);

function cardSelect(key: any) {
	$router.push({ name: key });
}

function langSelect(key: any) {
	console.log(key)
	lang.value = key;
	localStorage.setItem('lang', key);
}

function avatarSelect(key: string | number) {
	if ("logout" == key) {
		$api.common.logout().then((res: any) => {
			$msg.success(t('login.logout') + ' ' + t('success'));
			$store.commit('delAuth');
			$router.push({ name: 'home' });
		});
	} else if ("userInfo" == key) {
		showFun(t('home.user_info'), true, null, null);
	} else if ("editUserInfo" == key) {
		showFun(t("edit") + " " + t('home.user_info'), false, null, t("edit") + " " + t("success"));
	} else if ("editPassword" == key) {
		showPasswordFun(t("edit") + " " + t('home.password'), false, null, t("edit") + " " + t("success"));
	}
}

let msgNum = ref(0);
let msgs: any = ref([]);
function initMsg() {
	if (!$store.state.auth.user?.id) {
		return;
	}
	$api.common.msgUnreadPage({
		size: 10,
		sort: 'sendTime,desc'
	}).then((res: any) => {
		msgNum.value = res.totalElements;
		msgs.value = res.content;
	});
}
initMsg();
function lookAllFun() {
	$router.push({ name: "msg:page" });
}
window.addEventListener('onmessageWS', getSocketData);
function getSocketData(res: any) {
	let data = JSON.parse(res.detail.data);
	let dataType = data.type;
	if ('MSG' == dataType) {
		initMsg();
	}
}

function showFun(title: string, disabled: boolean, key: number | string | null, submitMsg: string | null) {
	titleModal.value = title;
	submitId.value = key;
	disabledModal.value = disabled;
	submitMsgModal.value = submitMsg;
	showModal.value = true;
}
function showPasswordFun(title: string, disabled: boolean, key: number | string | null, submitMsg: string | null) {
	titleModal.value = title;
	submitId.value = key;
	disabledModal.value = disabled;
	submitMsgModal.value = submitMsg;
	showPasswordModal.value = true;
}
let showModal = ref(false);
let showPasswordModal = ref(false);
let titleModal = ref("");
let submitId = ref<any>(null);
let disabledModal = ref(false);
let submitMsgModal = ref<any>(t("success"));
function closeFun() {
	showModal.value = false;
	showPasswordModal.value = false;
}

function submitFun(param: any) {
	let id = param.id
	if (id) {
		$api.common.userEdit(param).then((res: any) => {
			// queryFun();
			reInitAuth();
			$msg.success(submitMsgModal.value);
			closeFun();
		});
	}
}
function submitPasswordFun(param: any) {
	let id = param.id
	if (id) {
		$api.common.userEditPassword(param).then((res: any) => {
			$msg.success(submitMsgModal.value);
			closeFun();
			// 后端 editPassword 已 subject.logout，前端需同步清本地登录态
			$store.commit('delAuth');
			$store.commit('delToken');
			$router.push({ name: 'login' });
		});
	}
}

function renderLabel(item: any) {
	let click = item.click;
	if (click) {
		return h('div', {
			onclick: (e: any) => {
				e.stopPropagation();
				activeKey.value = item.key;
				//设置手机模式点击后关闭抽屉
				drawerShow.value = false;
				$router.push({ name: item.key });
			}
		}, item.label);
	} else {
		// todo
		return item.label as string;
	}
}

function renderIcon(item: any) {
	let click = item.click;
	let icon = item.icon;
	let props = null;
	if (click) {
		props = {
			onclick: (e: any) => {
				e.stopPropagation();
				activeKey.value = item.key;
				$router.push({ name: item.key });
			}
		}
	}
	if (icon) {
		return h(NIcon, props, { default: () => h(icon) })
	} else {
		return null;
	}
}
// function menuUpdate(key: string, item: MenuOption) {
// 	console.log(11, key)
// 	$router.push({ name: key });
// }

const cardOptions = [
	{
		label: t('esucard.fastDuel.title'),
		key: 'play'
	},
	{
		label: t('esucard.duel.title'),
		key: 'duel'
	},
	{
		label: t('esucard.userCardGroup.title'),
		key: 'userCardGroup'
	},
	{
		type: 'divider'
	},
	{
		label: t('esucard.rule.title'),
		key: 'rule'
	},
	{
		label: t('esucard.group.title'),
		key: 'group'
	},
	{
		label: t('esucard.card.title'),
		key: 'card'
	},
	{
		label: t('esucard.skillGroup.title'),
		key: 'skillGroup'
	},
	{
		label: t('esucard.skill.title'),
		key: 'skill'
	},

];

const langOptions = [
	{
		label: '中文(简体)',
		key: 'zh-CN',
		// icon: renderIcon(UserIcon)
	},
	{
		label: '中文(台彎)',
		key: 'zh-TW',
		// icon: renderIcon(UserIcon)
	},
	{
		label: 'English',
		key: 'en',
		// icon: renderIcon(UserIcon)
	}
];

const avatarOptions = [
	{
		label: t('home.user_info'),
		key: 'userInfo',
		// icon: renderIcon(UserIcon)
	},
	{
		label: t('edit') + t('home.user_info'),
		key: 'editUserInfo',
		// icon: renderIcon(UserIcon)
	},
	{
		label: t('edit') + t('home.password'),
		key: 'editPassword',
		// icon: renderIcon(UserIcon)
	},
	{
		label: t('home.logout'),
		key: 'logout',
		// icon: renderIcon(UserIcon)
	}
];

watch(() => $store.state.auth.perms, (newValue, oldValue) => {
	if ((!newValue || '' == newValue) && menuOptions.value.length == 0) {
		return;
	}
	initMenu();
})
watch(() => $store.state.auth.user.id, (newValue, oldValue) => {
	if (!newValue || '' == newValue) {
		return;
	}
	initMsg();
})
const menuOptions = ref<any[]>([]);
const initMenu = function () {
	$api.common.permMenu().then((perms: any) => {
		menuOptions.value = [];
		for (const index in perms) {
			if (Object.prototype.hasOwnProperty.call(perms, index)) {
				const perm = perms[index];
				const type = perm.type.field;
				if (type == "MENU") {
					menuOptions.value.push({
						label: perm.name,
						key: perm.code,
						id: perm.id,
						children: []
					});
				} else if (type == "PAGE") {
					if (!perm.parentId) {
						menuOptions.value.push({
							label: perm.name,
							key: perm.code,
							id: perm.id,
							click: true
						});
						continue;
					}
					var parent: any = menuOptions.value.find(function (item) {
						return item.id == perm.parentId;
					});
					if (!parent) {
						continue;
					}
					parent.children.push({
						label: perm.name,
						key: perm.code,
						id: perm.id,
						click: true
					});
				}
			}
		}
	});

}

// const menuOptions: any[] = [
// 	{
// 		label: t('esucard.fastDuel.title'),
// 		key: 'play',
// 		click: true
// 	},
// 	{
// 		label: t('esucard.duel.title'),
// 		key: 'duel',
// 		click: true
// 	},
// 	{
// 		label: t('esucard.userCardGroup.title'),
// 		key: 'userCardGroup',
// 		click: true
// 	},
// 	{
// 		label: t('esucard.setup'),
// 		key: 'setup',
// 		children: [
// 			{
// 				label: t('esucard.rule.title'),
// 				key: 'rule',
// 				click: true
// 			},
// 			{
// 				label: t('esucard.group.title'),
// 				key: 'group',
// 				click: true
// 			},
// 			{
// 				label: t('esucard.card.title'),
// 				key: 'card',
// 				click: true
// 			},
// 			{
// 				label: t('esucard.skillGroup.title'),
// 				key: 'skillGroup',
// 				click: true
// 			},
// 			{
// 				label: t('esucard.skill.title'),
// 				key: 'skill',
// 				click: true
// 			}
// 		]
// 	},]

// const menuOptions1: any[] = [
// 	{
// 		label: '书籍',
// 		key: 'book',
// 		click: true,
// 		icon: Book,
// 		children: [
// 			{
// 				type: 'group',
// 				label: '人物',
// 				key: 'people',
// 				children: [
// 					{
// 						label: '叙事者',
// 						key: 'narrator',
// 						// icon: renderIcon(PersonIcon)
// 					},
// 					{
// 						label: '羊男',
// 						key: 'sheep-man',
// 						// icon: renderIcon(PersonIcon)
// 					}
// 				]
// 			},
// 			{
// 				label: '饮品',
// 				key: 'beverage',
// 				// icon: renderIcon(WineIcon),
// 				children: [
// 					{
// 						label: '威士忌',
// 						key: 'whisky'
// 					}
// 				]
// 			}
// 		]
// 	}, {
// 		label: '影视',
// 		key: 'video',
// 		click: true,
// 		icon: Video,
// 		children: [
// 			{
// 				label: '排行榜',
// 				key: 'rank',
// 				// icon: renderIcon(BookIcon)
// 			}, {
// 				label: '标签',
// 				key: 'tag',
// 				// icon: renderIcon(BookIcon)
// 			}, {
// 				type: 'divider'
// 			}, {
// 				type: 'group',
// 				label: '我的',
// 				key: 'my_video',
// 				children: [{
// 					label: '想看',
// 					key: 'my_video_wish',
// 				}, {
// 					label: '在看',
// 					key: 'my_video_do',
// 				}, {
// 					label: '看过',
// 					key: 'my_video_done',
// 				}, {
// 					label: '搁置',
// 					key: 'my_video_hold',
// 				}, {
// 					label: '抛弃',
// 					key: 'my_video_abandon',
// 				}]
// 			}
// 		]
// 	}, {
// 		label: '音声',
// 		key: 'sound',
// 		click: true,
// 		icon: Music,
// 		children: [
// 			{
// 				label: '人物',
// 				key: 'people',
// 				icon: BookIcon
// 			}
// 		]
// 	}, {
// 		label: '游戏',
// 		key: 'game',
// 		click: true,
// 		icon: Gamepad,
// 		children: [
// 			{
// 				label: '人物',
// 				key: 'people',
// 				// icon: renderIcon(BookIcon)
// 			}
// 		]
// 	}
// ]

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_unref(NGrid), {
      cols: "6",
      style: {"border-bottom":"solid 1px rgb(239, 239, 245)"}
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(NGi), null, {
          default: _withCtx(() => [
            _createElementVNode("div", {
              class: "phone-hidden",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref($router).push({ name: 'home' }))),
              style: _normalizeStyle({ height: '100%', 'background-image': 'url(' + _unref(logoSrc) + ')', '-moz-background-size': 'contain', 'background-size': 'contain', 'background-position': 'center', 'background-repeat': 'no-repeat' })
            }, null, 4),
            (_unref(user).id)
              ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                  _createVNode(_unref(NButton), {
                    text: "",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_isRef(drawerShow) //@ts-ignore
 ? drawerShow.value = true : drawerShow = true))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(NIcon), { size: "48" }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(MenuIcon))
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(NDrawer), {
                    show: _unref(drawerShow),
                    "onUpdate:show": _cache[3] || (_cache[3] = ($event: any) => (_isRef(drawerShow) ? (drawerShow).value = $event : drawerShow = $event)),
                    width: "50%",
                    placement: "left",
                    style: {"padding":"0"}
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(NMenu), {
                        value: _unref(activeKey),
                        "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => (_isRef(activeKey) ? (activeKey).value = $event : activeKey = $event)),
                        mode: "vertical",
                        options: menuOptions.value,
                        "icon-size": 25,
                        "render-label": renderLabel,
                        "render-icon": renderIcon
                      }, null, 8, ["value", "options"])
                    ]),
                    _: 1
                  }, 8, ["show"])
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(_unref(NGi), { span: "4" }, {
          default: _withCtx(() => [
            (_unref(user).id)
              ? (_openBlock(), _createBlock(_unref(NSpace), {
                  key: 0,
                  justify: "center"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(NMenu), {
                      class: "phone-hidden",
                      value: _unref(activeKey),
                      "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => (_isRef(activeKey) ? (activeKey).value = $event : activeKey = $event)),
                      mode: "horizontal",
                      options: menuOptions.value,
                      "icon-size": 25,
                      "render-label": renderLabel,
                      "render-icon": renderIcon
                    }, null, 8, ["value", "options"])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(_unref(NGi), null, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_unref(NDropdown), {
                options: langOptions,
                onSelect: langSelect
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(NButton), {
                    text: "",
                    style: {"margin-right":"10px","min-width":"100px"}
                  }, {
                    icon: _withCtx(() => [
                      _createVNode(_unref(NIcon), null, {
                        default: _withCtx(() => [
                          _createVNode(_unref(LangIcon))
                        ]),
                        _: 1
                      })
                    ]),
                    default: _withCtx(() => [
                      _createTextVNode(" " + _toDisplayString(_unref(lang)), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              (_unref(user).id)
                ? (_openBlock(), _createBlock(_unref(NPopover), { key: 0 }, _createSlots({
                    trigger: _withCtx(() => [
                      _createVNode(_unref(NBadge), {
                        value: _unref(msgNum),
                        max: 99,
                        style: {"margin-right":"20px"}
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(NIcon), {
                            size: "24",
                            color: "#0e7a0d"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_unref(BellIcon))
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["value"])
                    ]),
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(msgs), (msg, index) => {
                        return (_openBlock(), _createBlock(_unref(NSpace), {
                          align: "center",
                          justify: "center"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_unref(NAvatar), {
                              size: "large",
                              src: _unref($api).commonUrl.filePreview('' + msg.sendUser.avatarId),
                              "fallback-src": require(`@/assets/img/default_avatar.png`)
                            }, null, 8, ["src", "fallback-src"]),
                            _createVNode(_unref(NSpace), {
                              vertical: "",
                              style: {"line-height":"13px"}
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("span", null, _toDisplayString(_unref(t)('system.msg.title') + '：' + msg.title), 1),
                                _createElementVNode("span", null, _toDisplayString(_unref(t)('system.msg.sendUser') + '：' + msg.sendUser.name + ' ' +
									_unref(t)('system.msg.sendTime')
									+
									'：' + msg.sendTime), 1)
                              ]),
                              _: 2
                            }, 1024)
                          ]),
                          _: 2
                        }, 1024))
                      }), 256)),
                      (_unref(msgs).length == 0)
                        ? (_openBlock(), _createBlock(_unref(NEmpty), {
                            key: 0,
                            size: "small",
                            description: _unref(t)('no_unread_msg')
                          }, null, 8, ["description"]))
                        : _createCommentVNode("", true)
                    ]),
                    _: 2
                  }, [
                    (_unref(msgs).length > 0)
                      ? {
                          name: "footer",
                          fn: _withCtx(() => [
                            _createVNode(_unref(NSpace), { justify: "end" }, {
                              default: _withCtx(() => [
                                _createVNode(_unref(NButton), {
                                  text: "",
                                  onClick: lookAllFun
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_unref(t)('look_all')), 1)
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          key: "0"
                        }
                      : undefined
                  ]), 1024))
                : _createCommentVNode("", true),
              (_unref(user).id)
                ? (_openBlock(), _createBlock(_unref(NDropdown), {
                    key: 1,
                    options: avatarOptions,
                    onSelect: avatarSelect
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(NAvatar), {
                        size: "large",
                        src: _unref($api).commonUrl.filePreview('' + _unref(user).avatarId),
                        "fallback-src": require(`@/assets/img/default_avatar.png`)
                      }, null, 8, ["src", "fallback-src"])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (!_unref(user).id)
                ? (_openBlock(), _createBlock(_unref(NButtonGroup), { key: 2 }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(NButton), {
                        type: "primary",
                        onClick: _cache[5] || (_cache[5] = ($event: any) => (_unref($router).push({ name: 'login' }))),
                        round: "",
                        ghost: ""
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_unref(t)('login.login')), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_unref(NButton), {
                        type: "primary",
                        onClick: _cache[6] || (_cache[6] = ($event: any) => (_unref($router).push({ name: 'register' }))),
                        round: "",
                        ghost: ""
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_unref(t)('login.register')), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_unref(NModal), {
      show: _unref(showModal),
      "onUpdate:show": _cache[7] || (_cache[7] = ($event: any) => (_isRef(showModal) ? (showModal).value = $event : showModal = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(UserInfoModal, {
          onClose: closeFun,
          title: _unref(titleModal),
          onSubmit: submitFun,
          disabled: _unref(disabledModal),
          submitId: _unref(submitId)
        }, null, 8, ["title", "disabled", "submitId"])
      ]),
      _: 1
    }, 8, ["show"]),
    _createVNode(_unref(NModal), {
      show: _unref(showPasswordModal),
      "onUpdate:show": _cache[8] || (_cache[8] = ($event: any) => (_isRef(showPasswordModal) ? (showPasswordModal).value = $event : showPasswordModal = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(EditPasswordModal, {
          onClose: closeFun,
          title: _unref(titleModal),
          onSubmit: submitPasswordFun,
          disabled: _unref(disabledModal),
          submitId: _unref(submitId)
        }, null, 8, ["title", "disabled", "submitId"])
      ]),
      _: 1
    }, 8, ["show"])
  ], 64))
}
}

})